// 秒数の表示変換
export function mmss(sec: number): string {
  if (!sec) return '00:00'

  const m = ((sec % 3600) / 60) | 0
  const s = sec % 60 | 0
  if (s < 0) return '00:00'

  const m0 = ('00' + m).slice(-2)
  const s0 = ('00' + s).slice(-2)
  const mmss = m0 + ':' + s0
  return mmss
}

export const RATE_LIST = [1.0, 1.2, 1.5, 2.0]
interface Bgm {
  num: number
  text: string
}
// BGMに番号がある理由:
//   bgmのファイル名が番号でつけられており、昔は1〜6番が存在したが音声刷新により7〜9となった経緯がある。
//   また、音声刷新時になぜ1〜6を上書きしなかったのかは、A/Bテストをするために新・旧の両方残しておく必要があったから。
export const FIRST_BGM_NUM = 0
export const LAST_BGM_NUM = 9
export const BGM_LIST: Bgm[] = [
  { num: FIRST_BGM_NUM, text: '『なし』' },
  { num: 7, text: '『Happy afternoon』' },
  { num: 8, text: '『Refresh morning』' },
  { num: LAST_BGM_NUM, text: '『Relax night』' },
]

export const getVoiceSettingRate = (): number => {
  if (typeof window !== 'undefined') {
    const localRate = localStorage.getItem('rate')
    return parseFloat(localRate) || RATE_LIST[0]
  }
  return RATE_LIST[0]
}

export const setVoiceSettingRate = (rate: number): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('rate', `${rate}`)
  }
}

export const getVoiceSettingBgm = (): Bgm => {
  if (typeof window !== 'undefined') {
    const localBgmNum = localStorage.getItem('bgm')
    const localBgm = BGM_LIST.filter((v) => v.num === parseInt(localBgmNum))
    if (localBgm.length === 0) return BGM_LIST[1]
    return localBgm[0]
  }
}

export const setVoiceSettingBgm = (bgm: number): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('bgm', `${bgm}`)
  }
}
